export const useCustomPath = () => useState<string | null>("customPath", () => null)
